import CharityImg1 from "@/assets/ascender-caridade-diversas-1.jpg";
import CharityImg2 from "@/assets/ascender-caridade-diversas-2.jpg";
import CharityImg3 from "@/assets/ascender-caridade-diversas-3.jpg";
import { useInViewOnce } from "@/hooks/useInViewOnce";
type CharityMockItem = {
  id: string;
  img: string;
  title: string;
  description: string;
};
const mockItems: CharityMockItem[] = [{
  id: "caridade-1",
  img: CharityImg1,
  title: "Cuidado que chega primeiro",
  description: "Quando falta o básico, a presença vira resposta — rápida, humana e respeitosa."
}, {
  id: "caridade-2",
  img: CharityImg2,
  title: "Cuidado com a vida",
  description: "Cuidadar da saúde e do bem estar também é cuidar da vida humana"
}, {
  id: "caridade-3",
  img: CharityImg3,
  title: "Escuta antes de qualquer coisa",
  description: "A gente não ‘resolve’ pessoas — a gente caminha junto, entendendo o que realmente pesa."
}];
export default function AscenderCharityWorks() {
  const {
    ref,
    inView
  } = useInViewOnce<HTMLElement>();
  return <section ref={ref} className="mt-12 space-y-6">
      <header className={["space-y-2", inView ? "animate-fade-in" : "opacity-0"].join(" ")}>
        <p className="section-title">Obras de caridade diversas</p>
        <h2 className="text-2xl font-semibold text-foreground">Onde houver necessidade, a gente quer estar perto.</h2>
        <p className="max-w-3xl text-sm text-muted-foreground">Nem todo cuidado vira manchete — mas sempre vira alívio. </p>
      </header>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {mockItems.map((item, idx) => <article key={item.id} className={["group card-ambient p-4", inView ? "animate-fade-in" : "opacity-0", idx % 3 === 0 ? "anim-delay-1" : idx % 3 === 1 ? "anim-delay-2" : "anim-delay-3"].join(" ")}>
            <div className="overflow-hidden rounded-2xl bg-muted shadow-[0_12px_50px_-20px_hsl(var(--foreground)/0.55)]">
              <img src={item.img} alt={`Imagem ilustrativa (mock): ${item.title}`} loading="lazy" width={400} height={208} className="h-52 w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
            </div>

            <h3 className="mt-4 text-sm font-semibold text-foreground">{item.title}</h3>
            <p className="mt-2 text-sm text-muted-foreground">{item.description}</p>
          </article>)}
      </div>
    </section>;
}